<script>
import { mapGetters } from 'vuex'

import Translatable from '@src/mixins/translatable.js'
import OrderListDay from '@components/e-shop/order-list-day.vue'

export default {
  components: {
    OrderListDay
  },
  mixins: [
    Translatable
  ],
  computed: {
    ...mapGetters('eShop', [
      'cards'
    ]),
    totalSum() {
      const cardsSum = this.cards.map(card => card.adultCardSum + card.studentCardSum)
      return cardsSum.reduce((sum, cur) => sum + cur, 0)
    }
  },
  methods: {
    selectType(type) {
      this.$store.commit('eShop/changePassType', type)
    },
  },
}
</script>

<template>
  <div v-if="totalSum" class="list-items">
    <OrderListDay v-for="(card, index) in cards" :key="index" :card="card"/>
    <div class="list-total">
      <div class="list-item-text type sum">{{ getTranslatedContent('ESHOP_review_order_total') }}</div>
      <div class="list-item-text calc"></div>
      <div class="list-item-text total sum green">{{`${totalSum} EUR`}}</div>
      <div class="list-item-text empty"></div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.list-items :first-child {
  margin-top: 5px;
}

.list-item, .list-total{
  width: 657px;
  height: 70px;
  border-top: 1px solid $dark-gray;
  border-bottom: 1px solid $dark-gray;
  padding: 0 28px;

  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.list-total {
  height: 80px;
  border-top: none;
}

.list-item-text {
  font-family: Open Sans Bold;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 18px;
  text-transform: uppercase;
  text-align: center;
  color: $gray;

  margin-right: 20px;

  &.type {
    min-width: 170px;
    text-align: left;
  }

  &.calc {
    min-width: 280px;
  }

  &.total {
    min-width: 130px;
    text-align: left;
  }

  &.sum {
    font-size: 18px;
    line-height: 23px;
    color: $black;
  }

  &.green {
    color: $green;
  }
}

@media only screen and (max-width: $screen-width-xs) {

  .list-items {
    width: 100%;
  }

  .list-total{
    width: 100%;
    height: 80px;
    padding: 0;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .list-item-title {
    font-size: 16px;
    line-height: 21px;
    margin: 0 0 25px 8px;
  }

  .list-item-text {
    margin-right: 5px;

    &.type {
      min-width: 112px;
      text-align: left;
      margin-left: 8px;
    }

    &.calc {
      min-width: 80px;
    }

    &.total {
      min-width: 43px;
      text-align: left;
    }

    &.green {
      margin-right: 20px;
    }
  }
}

</style>
